import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ArchiAppsKeyType {
  aiStudio: LocalesKey;
  create: LocalesKey;
  createApp: LocalesKey;
  delete: LocalesKey;
  deleteApp: LocalesKey;
  editApp: LocalesKey;
  editAiStudio: LocalesKey;
  iframeUrl: LocalesKey;
  missingIframeUrl: LocalesKey;
  plural: LocalesKey;
  singular: LocalesKey;
  update: LocalesKey;
}

export const archiAppsKeys = keyPathMirror<ArchiAppsKeyType, string>(
  {
    aiStudio: null,
    create: null,
    createApp: null,
    delete: null,
    deleteApp: null,
    editApp: null,
    editAiStudio: null,
    iframeUrl: null,
    missingIframeUrl: null,
    plural: null,
    singular: null,
    update: null
  },
  'models.archiApps.'
);
